<template>
    <ToggleSimple @update:open="toggleOpen = $event">
        <template #toggle>
            <div class="left">
                <div v-if="$te(`fields.${name}.label`)" class="toggle-text">
                    {{ $t(`fields.${name}.label`) }}
                    <span v-if="isActive">
                        <div class="icon-check-dark"></div>
                    </span>
                </div>
                <div v-if="$te(`fields.${name}.description`)" class="toggle-description">
                    {{ $t(`fields.${name}.description`) }}
                </div>
            </div>
            <div class="right">
                <div v-if="isActive" class="reset" @click="resetSection">
                    <div class="icon-reset-pos"></div>
                </div>
                <div class="toggle-icon"></div>
            </div>
        </template>

        <template #content>
            <div :class="cssClassOptions">
                <CustomCheckboxTagsFilter
                    :modelValue="modelValue"
                    :inputKey="name"
                    @update:modelValue="onChanged"
                    :showLabel="false"
                    :showDescription="false"
                    ref="optionsTags"
                />
            </div>
        </template>
    </ToggleSimple>
</template>

<script>
    import ToggleSimple from '@/components/misc/ToggleSimple';
    import CustomCheckboxTagsFilter from '@/components/inputs/CustomCheckboxTagsFilter';

    export default {
        name: "OptionsTags",
        components: {
            ToggleSimple,
            CustomCheckboxTagsFilter
        },
        props: {
            modelValue: {
                type: Array,
                default: () => []
            },
            defaultVal: {
                type: Array,
                default: () => []
            },
            showDescriptions: {
                type: Boolean,
                default: true
            },
            cssClassOptions: {
                type: String,
                default: 'options-type-4'
            }
        },
        data() {
            return {
                name: 'prospects_filter_tags_alt',
                toggleOpen: false
            };
        },
        computed: {
            isActive() {
                return JSON.stringify(this.modelValue) !== JSON.stringify(this.defaultVal);
            }
        },
        methods: {
            resetSection(event = null) {
                if (event) {
                    event.stopPropagation()
                }
                this.$emit('update:modelValue', this.defaultVal);
            },
            onChanged(newValue) {
                this.$emit('update:modelValue', newValue);
            },
        }
    }
</script>